module.exports = __webpack_public_path__ + "img/18.049440c5.svg";